export default __webpack_public_path__ + "static/media/myinvitation.40257102.svg";